import SvgIcon from '@/components/SvgIcon';

export const install = (app) => {
    app.component('SvgIcon', SvgIcon);

    // 预渲染时，需要预加载的图标
    const prerenderIcons = ['./handicap-all.svg'];

    const req = require.context('./svg', true, /\.svg$/);
    const requireAll = (requireContext) => {
        const res = requireContext.keys().filter((item) => (window.sfe.prerender ? prerenderIcons.indexOf(item) > -1 : true)).map(requireContext);
        return res;
    };
    requireAll(req);
};
